export default (store, { itemId, actionType }) => {
  if (itemId === store.state.user.id) {
    store.dispatch('user/changeNotification'); // app.GetLoggedInUser()
  } else if (actionType === 'edited') {
    store.dispatch('people/changeNotification', itemId);
  }
};
